import React, { Component } from "react";
import {
  PageHeader,
  Form,
  Select,
  Row,
  Col,
  DatePicker,
  Typography,
  message,
  Alert,
  Spin,
  Tabs,
  Popconfirm,
  Table,
  Tooltip,
  Space,
} from "antd";
import { EyeOutlined, SendOutlined } from "@ant-design/icons";
import axios from "axios";
import { connect } from "react-redux";
import {
  SelectItem,
  ButtonItem,
  TableItem,
  SwitchItem,
  InputItem,
} from "../../../Components/Items";
import FormItem from "../../../Components/FormItem";
import ModalDetalleEnvio from "./ModalDetalleEnvio/ModalDetalleEnvio";
import ModalMandarEstadoCuenta from "./ModalMandarEstadoCuenta/ModalMandarEstadoCuenta";

import moment from "moment";
import "moment/locale/es";
moment.locale("es");

const { RangePicker } = DatePicker;
const { TabPane } = Tabs;
const { Option } = Select;
const { Title, Paragraph } = Typography;

const opcionesFrecuencia = [
  { id: "Desactivado", nombre: "Desactivado" },
  { id: "Diario", nombre: "Diario" },
  { id: "Semanal", nombre: "Semanal" },
  { id: "Quincenal", nombre: "Quincenal" },
  { id: "Mensual", nombre: "Mensual" },
  { id: "DiaEspecifico", nombre: "Por Día de la Semana" },
];

const diasSemana = [
  { id: "lunes", nombre: "Lunes" },
  { id: "martes", nombre: "Martes" },
  { id: "miércoles", nombre: "Miércoles" },
  { id: "jueves", nombre: "Jueves" },
  { id: "viernes", nombre: "Viernes" },
  { id: "sábado", nombre: "Sábado" },
  { id: "domingo", nombre: "Domingo" },
];

class ProgramarRecordatorios extends Component {
  formRef = React.createRef();
  formRefAvanzada = React.createRef();

  state = {
    loading: false,
    opcionesFrecuencia,
    frecuenciaSeleccionada: null,
    diaEspecificoSeleccionado: null,
    fechaMensualSeleccionada: null,
    resumen: "",
    clientesConDeuda: [],
    historialRecordatorios: [],
    configuracionCargada: false,
    clientesCargados: false,
    historialCargado: false,
    modalDetalleVisible: false,
    detalleEnvioId: null,
    fechaInicio: null,
    fechaFin: null,
    historialFiltrado: [],
    selectClientesIds: [],
    originalSelectClientesIds: [],
    modalMandarCorreoVisible: false,
    clienteIdParaCorreo: null,
    sinRemisionesParaCorreo: false,
    correoReenvioActivo: false,
    correoReenvio: "",
    configuracionAvanzadaCargada: false,
  };

  componentDidMount() {
    this.obtenerConfiguracion(true);
  }

  obtenerConfiguracion = async (inicial = false) => {
    //Si ya se cargo no se vuelve a cargar
    if (this.state.configuracionCargada && !inicial) return;

    this.setState({ loading: true });
    await axios
      .post(
        "empresas/obtenerConfiguracionRecordatoriosCxC",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data?.success && res.data?.configuracion) {
          const config = res.data.configuracion;

          const newState = {
            frecuenciaSeleccionada: config.frecuencia || "Desactivado",
            diaEspecificoSeleccionado: config.diaEspecifico || null,
            fechaMensualSeleccionada: config.diaDelMes
              ? moment().set("date", config.diaDelMes)
              : null,
            configuracionCargada: true,
          };

          if (inicial) {
            const idsCargados = config.clientesExcluidos || [];
            newState.selectClientesIds = idsCargados;
            newState.originalSelectClientesIds = idsCargados;
          }
          this.setState(newState);
          if (this.formRef.current) {
            this.formRef.current.setFieldsValue({
              enviarVencidos: config.enviarVencidos,
              sinRemisionesRecordatoriosCxC: config.sinRemisionesRecordatoriosCxC,
              metodoPago: config.metodoPago ?? 0,
            });
          }
          this.actualizarResumen();
        }
      })
      .catch((error) => {
        console.error(error);
        message.error("Error al cargar la configuración de recordatorios.");
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  consultarClientesConDeuda = async () => {
    if (this.state.clientesCargados) return;
    this.setState({ loading: true });

    await axios
      .post(
        "clientes/clientesConCuentrasPorCobrar",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data?.success === 2 && res.data?.clientes?.length) {
          this.setState({ clientesConDeuda: res.data.clientes });
        }
      })
      .catch((error) => {
        console.error(error);
        message.error("Error al cargar clientes con cuentas por cobrar.");
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  consultarHistorialCorreos = async () => {
    if (this.state.historialCargado) return;
    this.setState({ loading: true });
    await axios
      .post(
        "correosEnviadosGeneral/obtenerCorreosGeneralPorTipo",
        { empresaId: this.props.empresaId, tipoCorreo: "Recordatorio CxC" },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data?.success === 2 && res.data?.historial?.length) {
          this.setState(
            {
              historialRecordatorios: res.data.historial,
              historialFiltrado: res.data.historial,
              historialCargado: true,
            },
            this.aplicarFiltroFechas
          );
        } else {
          this.setState({
            historialRecordatorios: [],
            historialFiltrado: [],
            historialCargado: true,
          });
        }
      })
      .catch((error) => {
        console.error(error);
        message.error("Error al cargar el historial de recordatorios.");
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  handleFrecuenciaChange = (valor) => {
    this.setState({
      frecuenciaSeleccionada: valor,
      diaEspecificoSeleccionado: null,
      fechaMensualSeleccionada: null,
      resumen: "",
    });
  };

  handleDiaChange = (valor) => {
    this.setState({ diaEspecificoSeleccionado: valor }, this.actualizarResumen);
  };

  handleFechaChange = (fecha) => {
    this.setState({ fechaMensualSeleccionada: fecha }, this.actualizarResumen);
  };

  actualizarResumen = () => {
    const {
      frecuenciaSeleccionada,
      diaEspecificoSeleccionado,
      fechaMensualSeleccionada,
    } = this.state;
    let resumen = "";

    switch (frecuenciaSeleccionada) {
      case "Diario":
        resumen = "El recordatorio se enviará cada día.";
        break;
      case "Semanal":
        resumen = "El recordatorio se enviará cada lunes.";
        break;
      case "Quincenal":
        resumen =
          "El recordatorio se enviará cada día 15 y el último día del mes.";
        break;
      case "Mensual":
        if (fechaMensualSeleccionada) {
          resumen = `El recordatorio se enviará el día ${moment(
            fechaMensualSeleccionada
          ).format("D")} de cada mes.`;
        } else {
          resumen =
            "Selecciona el día del mes en que se enviará el recordatorio.";
        }
        break;
      case "DiaEspecifico":
        if (diaEspecificoSeleccionado) {
          resumen = `El recordatorio se enviará cada ${diaEspecificoSeleccionado}.`;
        } else {
          resumen =
            "Selecciona el día de la semana para enviar el recordatorio.";
        }
        break;
      default:
        resumen = "";
    }

    this.setState({ resumen });
  };

  handleGuardar = async () => {
    const {
      frecuenciaSeleccionada,
      diaEspecificoSeleccionado,
      fechaMensualSeleccionada,
    } = this.state;

    if (!frecuenciaSeleccionada) {
      message.warning("Selecciona una frecuencia antes de guardar.");
      return;
    }

    if (
      frecuenciaSeleccionada === "DiaEspecifico" &&
      !diaEspecificoSeleccionado
    ) {
      message.warning("Selecciona un día de la semana.");
      return;
    }

    if (frecuenciaSeleccionada === "Mensual" && !fechaMensualSeleccionada) {
      message.warning("Selecciona una fecha para el recordatorio mensual.");
      return;
    }

    const enviarVencidos = this.formRef.current
      ? this.formRef.current.getFieldValue("enviarVencidos")
      : false;

    const sinRemisionesRecordatoriosCxC = this.formRef.current
      ? this.formRef.current.getFieldValue("sinRemisionesRecordatoriosCxC")
      : false;

    const metodoPago = this.formRef.current
      ? this.formRef.current.getFieldValue("metodoPago")
      : 0;

    const { selectClientesIds } = this.state;
    await axios
      .post(
        "empresas/guardarConfiguracionRecordatoriosCxC",
        {
          empresaId: this.props.empresaId,
          frecuencia: frecuenciaSeleccionada,
          diaEspecifico: diaEspecificoSeleccionado,
          diaDelMes: fechaMensualSeleccionada
            ? moment(fechaMensualSeleccionada).date()
            : null,
          usuarioId: this.props.usuarioId,
          enviarVencidos: enviarVencidos,
          sinRemisionesRecordatoriosCxC: sinRemisionesRecordatoriosCxC,
          metodoPago: metodoPago,
          clientesExcluidos: selectClientesIds,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success) {
          message.success("Configuración guardada correctamente.");
        } else {
          message.warning(
            res.data.message || "No se pudo guardar la configuración."
          );
        }
      })
      .catch((error) => {
        console.error(error);
        message.error("Error al guardar la configuración.");
      });
  };

  enviarRecordatoriosAhora = async () => {
    this.setState({ loading: true });
    await axios
      .post(
        "recordatoriosProgramados/enviarRecordatoriosProgramadosCxC",
        {
          empresaId: this.props.empresaId,
          usuarioId: this.props.usuarioId,
          manual: true,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Los recordatorios fueron enviados correctamente.");
        } else {
          message.warning(
            res.data.message || "No se pudieron enviar los recordatorios."
          );
        } 
      })
      .catch((error) => {
        console.error(error);
        message.error("Error al enviar los recordatorios.");
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  obtenerConfiguracionAvanzada = async () => {
    if (this.state.configuracionAvanzadaCargada) return;
    this.setState({ loading: true });
    await axios
      .post(
        "empresas/obtenerConfiguracionAvanzadaRecordatorios",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data?.success) {
          const config = res.data.configuracion || {};
          this.setState({ configuracionAvanzadaCargada: true });
          if (this.formRefAvanzada.current) {
            this.formRefAvanzada.current.setFieldsValue({
              correoReenvioActivo: config.correoReenvioActivo || false,
              correoReenvio: config.correoReenvio || "",
            });
          }
        }
      })
      .catch((error) => {
        console.error(error);
        message.error("Error al cargar la configuración avanzada.");
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  handleGuardarAvanzado = async () => {
    const values = this.formRefAvanzada.current?.getFieldsValue();
    const { correoReenvioActivo, correoReenvio } = values || {};

    if (correoReenvioActivo && !correoReenvio) {
      message.warning("Escribe un correo de reenvío antes de activarlo.");
      return;
    }

    this.setState({ loading: true });
    await axios
      .post(
        "empresas/guardarConfiguracionAvanzadaRecordatorios",
        {
          empresaId: this.props.empresaId,
          usuarioId: this.props.usuarioId,
          correoReenvioActivo: correoReenvioActivo || false,
          correoReenvio: correoReenvio || "",
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success) {
          message.success("Configuración avanzada guardada correctamente.");
        } else {
          message.warning(res.data.message || "No se pudo guardar la configuración avanzada.");
        }
      })
      .catch((error) => {
        console.error(error);
        message.error("Error al guardar la configuración avanzada.");
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  handleTabChange = (key) => {
    switch (key) {
      case "1": // Configuración de Recordatorios
        this.obtenerConfiguracion();
        break;
      case "2": // Clientes con cuentas por cobrar
        this.consultarClientesConDeuda();
        break;
      case "3": // Historial de Recordatorios
        this.consultarHistorialCorreos();
        break;
      case "4": // Configuración Avanzada
        this.obtenerConfiguracionAvanzada();
        break;
      default:
        break;
    }
  };

  handleVerDetalle = (record) => {
    this.setState({
      modalDetalleVisible: true,
      detalleEnvioId: record,
    });
  };

  handleCloseModal = () => {
    this.setState({
      modalDetalleVisible: false,
      detalleEnvioId: null,
    });
  };

  aplicarFiltroFechas = () => {
    const { historialRecordatorios, fechaInicio, fechaFin } = this.state;

    if (!fechaInicio && !fechaFin) {
      //Si no hay filtros de fechas se muestran todos
      this.setState({ historialFiltrado: historialRecordatorios });
    }

    const inicio = fechaInicio ? fechaInicio.startOf("day") : null;
    const fin = fechaFin ? fechaFin.startOf("day") : null;

    const historialFiltrado = historialRecordatorios.filter((record) => {
      const fecha = moment(record.createdAt);

      const despuesDelInicio =
        !inicio || fecha.isSame(inicio, "day") || fecha.isAfter(inicio);
      const antesDelFin =
        !fin || fecha.isSame(fin, "day") || fecha.isBefore(fin);

      return despuesDelInicio && antesDelFin;
    });

    this.setState({ historialFiltrado: historialFiltrado });
  };
  onChangeRangoFechas = (dates) => {
    const [inicio, fin] = dates || [null, null];

    this.setState(
      {
        fechaInicio: inicio,
        fechaFin: fin,
      },
      this.aplicarFiltroFechas
    );
  };

  onSelectedRowKeyChange = (selectClientesIds) => {
    this.setState({ selectClientesIds });
  };

  enviarCorreoIndividual = async (clienteId) => {
    await axios
    .post("recordatoriosProgramados/enviarRecordatorioIndividual", 
      {
        empresaId: this.props.empresaId,
        usuarioId: this.props.usuarioId,
        clienteId: clienteId
      }
    )
    .then((res) =>{
        if (res.data.success === 2) {
          message.success("Enviado correctamente.");
        } else {
          message.warning(
            res.data.message || "No se pudo enviar."
          );
        } 
    })
    .catch((error) =>{
      console.error(error);
    })
  }

  abrirModalMandarCorreo = (clienteId, sinRemisiones = false) => {
    this.setState({
      modalMandarCorreoVisible: true,
      clienteIdParaCorreo: clienteId,
      sinRemisionesParaCorreo: sinRemisiones,
    });
  };

  cerrarModalMandarCorreo = () => {
    this.setState({
      modalMandarCorreoVisible: false,
      clienteIdParaCorreo: null,
      sinRemisionesParaCorreo: false,
    });
  };

  render() {
    const {
      frecuenciaSeleccionada,
      diaEspecificoSeleccionado,
      fechaMensualSeleccionada,
      resumen,
      clientesConDeuda,
      loading,
      modalDetalleVisible,
      detalleEnvioId,
      historialFiltrado,
      fechaFin,
      fechaInicio,
      selectClientesIds,
      originalSelectClientesIds,
    } = this.state;

    const hayCambiosEnClientes =
      JSON.stringify([...selectClientesIds].sort()) !==
      JSON.stringify([...originalSelectClientesIds].sort());

    const rowSelection = {
      selectedRowKeys: selectClientesIds,
      onChange: this.onSelectedRowKeyChange,
      columnTitle: "Excluir",
      columnWidth: 100,
      selections: [
        Table.SELECTION_ALL,
        Table.SELECTION_INVERT,
        Table.SELECTION_NONE,
      ],
    };
    //Columnas para la tabla de clientes con deuda
    const columnsClientes = [
      {
        title: "Cliente",
        dataIndex: "cliente",
        key: "cliente",
        responsive: ["sm", "md", "lg"],
        buscar: 'cliente',
      },
      {
        title: "Deuda",
        key: "resumen",
        responsive: ["xs"], // Visible solo en móvil
        render: (record) => (
          <div>
            <div style={{ fontWeight: "bold" }}>{record.cliente}</div>
            <div>{record.correo}</div>
            <div style={{ fontSize: 13, color: "#ff4d4f", marginTop: 4 }}>
              {record.totalPendiente?.toLocaleString("es-MX", {
                style: "currency",
                currency: "MXN",
              })}{" "}
              ({record.cantidadFacturas} facturas)
            </div>
          </div>
        ),
      },
      {
        title: "Correo electrónico",
        dataIndex: "correo",
        key: "correo",
        responsive: ["md", "lg"],
      },
      {
        title: "Facturas pendientes",
        dataIndex: "cantidadFacturas",
        key: "cantidadFacturas",
        align: "center",
        responsive: ["sm", "md", "lg"],
      },
      {
        title: "Total pendiente",
        dataIndex: "totalPendiente",
        key: "totalPendiente",
        align: "right",
        responsive: ["sm", "md", "lg"],
        render: (val) =>
          val?.toLocaleString("es-MX", {
            style: "currency",
            currency: "MXN",
          }),
      },
      {
        title: "Acciones",
        dataIndex: "accion",
        key: "accion",
        align: "right",
        responsive: ["sm", "md", "lg"],
        render: (value, record) => {
          return (
            <Space>
              <Tooltip title="Previsualizar y enviar de manera individual" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  key={`ver-${record.id}`}
                  type="default"
                  size="small"
                  azul
                  icon={<SendOutlined />}
                  onClick={() => this.abrirModalMandarCorreo(record.id, false)}
                >
                </ButtonItem>
              </Tooltip>
              <Tooltip title="Previsualizar y enviar de manera individual sin remisiones" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  key={`ver-sr-${record.id}`}
                  type="default"
                  size="small"
                  naranja
                  icon={<SendOutlined />}
                  onClick={() => this.abrirModalMandarCorreo(record.id, true)}
                >
                </ButtonItem>
              </Tooltip>
            </Space>
          );
        },
      },
    ];
    //Columnas para la tabla de historial de recordatorios

    const columnsHistorial = [
      {
        title: "Envío de correos",
        key: "envioCorreos",
        responsive: ["sm", "md", "lg"],
        render: (record) => (
          <div
            style={{
              background: "#fff",
              border: "1px solid #e8e8e8",
              borderRadius: 8,
              padding: 16,
              boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                marginBottom: 12,
                paddingBottom: 12,
                borderBottom: "1px solid #f0f0f0",
              }}
            >
              <div>
                <div
                  style={{ fontWeight: 600, color: "#262626", fontSize: 14 }}
                >
                  {moment(record.createdAt).format("DD/MM/YYYY HH:mm")}
                </div>
                <div style={{ color: "#2c2c2cff", fontSize: 16, marginTop: 4 }}>
                  <strong>
                    {record.tipoCorreo === "Recordatorio CxC"
                      ? "Recordatorio Cuentas por Cobrar"
                      : record.tipoCorreo}
                  </strong>
                </div>
              </div>
              {record.usuario && (
                <div
                  style={{ marginBottom: 12, fontSize: 13, color: "#595959" }}
                >
                  <span style={{ color: "#8c8c8c" }}>
                    {record.tipoEnvio === "Automático"
                      ? "Programado por:"
                      : "Enviado por:"}
                  </span>{" "}
                  <span style={{ fontWeight: 500 }}>
                    {record.usuario.nombre} {record.usuario.apellidoPaterno}{" "}
                    {record.usuario.apellidoMaterno}
                  </span>
                </div>
              )}

              <div
                style={{
                  background:
                    record.tipoEnvio === "Automático" ? "#f0f5ff" : "#fff7e6",
                  color:
                    record.tipoEnvio === "Automático" ? "#1890ff" : "#fa8c16",
                  padding: "4px 12px",
                  borderRadius: 4,
                  fontSize: 12,
                  fontWeight: 500,
                }}
              >
                {record.tipoEnvio}
              </div>
            </div>

            {/* Estadísticas en grid */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns:
                  record.cantidadNoEnviados > 0
                    ? "repeat(3, 1fr)"
                    : "repeat(2, 1fr)",
                gap: 12,
              }}
            >
              {/* Enviados */}
              <div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                    gap: 5,
                    marginBottom: 6,
                  }}
                >
                  <div
                    style={{ fontSize: 24, fontWeight: 600, color: "#52c41a" }}
                  >
                    {record.cantidadEnviados}
                  </div>
                  <div
                    style={{
                      fontSize: 11,
                      color: "#8c8c8c",
                      textTransform: "uppercase",
                      letterSpacing: 0.5,
                    }}
                  >
                    Enviados
                  </div>
                </div>
                <div style={{ fontSize: 11, color: "#999" }}>
                  Cuentas enviadas exitosamente
                </div>
              </div>

              {/* No Enviados */}
              {record.cantidadNoEnviados > 0 && (
                <div>
                  {/* Usamos flexbox para alinear la cantidad y el texto en la misma línea */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      gap: 5,
                      marginBottom: 6,
                    }}
                  >
                    <div
                      style={{
                        fontSize: 24,
                        fontWeight: 600,
                        color: "#ff4d4f",
                      }}
                    >
                      {record.cantidadNoEnviados}
                    </div>
                    <div
                      style={{
                        fontSize: 11,
                        color: "#8c8c8c",
                        textTransform: "uppercase",
                        letterSpacing: 0.5,
                      }}
                    >
                      No enviados
                    </div>
                  </div>
                </div>
              )}

              {/* Total */}
              <div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                    gap: 5,
                    marginBottom: 6,
                  }}
                >
                  <div
                    style={{ fontSize: 20, fontWeight: 600, color: "#262626" }}
                  >
                    {record.cobroTotal?.toLocaleString("es-MX", {
                      style: "currency",
                      currency: "MXN",
                    })}
                  </div>
                  <div
                    style={{
                      fontSize: 11,
                      color: "#8c8c8c",
                      textTransform: "uppercase",
                      letterSpacing: 0.5,
                    }}
                  >
                    Total Cobrado
                  </div>
                </div>
                <div style={{ fontSize: 11, color: "#999" }}>
                  Monto total pendiente cubierto
                </div>
              </div>
            </div>
          </div>
        ),
      },
      {
        title: "Resumen Envío",
        key: "resumen_movil",
        responsive: ["xs"],
        render: (record) => (
          <div style={{ borderBottom: "1px solid #f0f0f0", paddingBottom: 10 }}>
            <div style={{ fontWeight: "bold" }}>
              {moment(record.createdAt).format("DD/MM/YYYY HH:mm")} (
              {record.tipoEnvio})
            </div>
            <div style={{ fontSize: 13, marginTop: 4 }}>
              <span style={{ color: "#52c41a", fontWeight: "bold" }}>
                {record.cantidadEnviados}
              </span>{" "}
              Enviados
              {record.cantidadNoEnviados > 0 && (
                <>
                  {" "}
                  |{" "}
                  <span style={{ color: "#ff4d4f", fontWeight: "bold" }}>
                    {record.cantidadNoEnviados}
                  </span>{" "}
                  No enviados
                </>
              )}
            </div>
            <div style={{ marginTop: 4, color: "#262626" }}>
              Total:{" "}
              {record.cobroTotal?.toLocaleString("es-MX", {
                style: "currency",
                currency: "MXN",
              })}
            </div>
          </div>
        ),
      },
      {
        title: "Acciones",
        key: "acciones",
        width: "15%",
        align: "center",
        responsive: ["sm", "md", "lg"],
        render: (record) => (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 8,
              alignItems: "center",
              padding: "8px 0",
            }}
          >
            {" "}
            <button
              onClick={() => this.handleVerDetalle(record)}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
                width: "100%",
                height: "100%",
                padding: "10px 16px",
                background: "#fff",
                border: "1px solid #d9d9d9",
                borderRadius: 6,
                color: "#595959",
                fontSize: 13,
                fontWeight: 500,
                cursor: "pointer",
                transition: "all 0.2s ease",
                outline: "none",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = "#1890ff";
                e.currentTarget.style.color = "#1890ff";
                e.currentTarget.style.background = "#f0f5ff";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = "#d9d9d9";
                e.currentTarget.style.color = "#595959";
                e.currentTarget.style.background = "#fff";
              }}
            >
              <EyeOutlined style={{ fontSize: 14 }} />
              <span>Ver Detalles</span>
            </button>
          </div>
        ),
      },
    ];
    return (
      <>
        <PageHeader
          title="Programar Recordatorios"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        <div className="card-background" style={{ paddingTop: 5 }}>
          <Spin spinning={loading}>
            <Tabs defaultActiveKey={1} onChange={this.handleTabChange}>
              <TabPane tab="Configuración de Recordatorios" key={1} forceRender>
                <div
                  style={{
                    backgroundColor: "white",
                    padding: 20,
                    borderRadius: 10,
                    border: "1px solid #f0f0f0",
                  }}
                >
                  <Title strong level={4}>
                    Configuración Envío Automatíco
                  </Title>

                  <Alert
                    message="Esta configuración define la frecuencia con la que se enviarán recordatorios automáticos por correo electrónico a los clientes con cuentas por cobrar pendientes."
                    type="info"
                    showIcon
                    style={{ marginBottom: 10 }}
                  />
                  <Alert
                    message="Es importante asegurar que el cliente tenga registrado un correo."
                    type="warning"
                    showIcon
                    style={{ marginBottom: 20 }}
                  />

                  <Form ref={this.formRef} layout="vertical">
                    <Row gutter={16}>
                      <Col xs={24} span={8}>
                        <FormItem label="Frecuencia">
                          <SelectItem
                            placeholder="Selecciona una frecuencia"
                            onChange={(v) => {
                              this.handleFrecuenciaChange(v);
                              setTimeout(this.actualizarResumen, 100);
                            }}
                            value={frecuenciaSeleccionada}
                          >
                            {opcionesFrecuencia.map((op) => (
                              <Option key={op.id} value={op.id}>
                                {op.nombre}
                              </Option>
                            ))}
                          </SelectItem>
                        </FormItem>
                      </Col>

                      {frecuenciaSeleccionada === "DiaEspecifico" && (
                        <Col xs={24} span={8}>
                          <FormItem label="Día específico">
                            <SelectItem
                              placeholder="Selecciona un día"
                              onChange={this.handleDiaChange}
                              value={diaEspecificoSeleccionado}
                            >
                              {diasSemana.map((dia) => (
                                <Option key={dia.id} value={dia.id}>
                                  {dia.nombre}
                                </Option>
                              ))}
                            </SelectItem>
                          </FormItem>
                        </Col>
                      )}

                      {frecuenciaSeleccionada === "Mensual" && (
                        <Col xs={24} span={8}>
                          <FormItem label="Día del mes">
                            <DatePicker
                              format="DD"
                              picker="date"
                              onChange={this.handleFechaChange}
                              value={fechaMensualSeleccionada}
                              placeholder="Selecciona el día"
                              style={{ width: "100%" }}
                            />
                          </FormItem>
                        </Col>
                      )}
                    </Row>
                    <Row>
                      <FormItem
                        name="enviarVencidos"
                        label="Enviar únicamente correo a ventas vencidas"
                        valuePropName="checked"
                        initialValue={false}
                        margin
                      >
                        <SwitchItem />
                      </FormItem>
                    </Row>
                    <Alert
                      message="Solo se enviará el correo a los clientes con cuentas vencidas según la fecha configurada para el envío. Si la opción está desactivada, se enviará a todos los clientes con cuentas por cobrar."
                      type="info"
                      showIcon
                      style={{ marginBottom: 10 }}
                    />
                    <Row>
                      <FormItem
                        name="sinRemisionesRecordatoriosCxC"
                        label="Enviar recordatorios sin remisiones"
                        valuePropName="checked"
                        initialValue={false}
                        margin
                      >
                        <SwitchItem />
                      </FormItem>
                    </Row>
                    <Alert
                      message="Si la opción está activada, los recordatorios automáticos se enviarán excluyendo las remisiones del estado de cuenta."
                      type="info"
                      showIcon
                      style={{ marginBottom: 10 }}
                    />
                    <Row gutter={16}>
                      <Col xs={24} span={8}>
                        <FormItem
                          name="metodoPago"
                          label="Enviar por método de pago"
                          initialValue={0}
                        >
                          <SelectItem placeholder="Selecciona un método de pago">
                            <Option value={0}>Todos</Option>
                            <Option value={1}>Contado</Option>
                            <Option value={2}>Crédito</Option>
                          </SelectItem>
                        </FormItem>
                      </Col>
                    </Row>
                    <Row justify="space-between" align="middle">
                      <Col>
                        {resumen && (
                          <Paragraph
                            type="secondary"
                            style={{
                              fontSize: 15,
                              marginBottom: 0,
                              color: "#555",
                            }}
                          >
                            {resumen}
                          </Paragraph>
                        )}
                      </Col>
                      <Col>
                        <ButtonItem
                          type="primary"
                          onClick={this.handleGuardar}
                          loading={this.state.loading}
                        >
                          Guardar configuración
                        </ButtonItem>
                      </Col>
                    </Row>
                  </Form>
                </div>
                <div
                  style={{
                    backgroundColor: "white",
                    padding: 20,
                    borderRadius: 10,
                    border: "1px solid #f0f0f0",
                    marginTop: 20,
                  }}
                >
                  <Title strong level={4}>
                    Envío Manual de Correos
                  </Title>
                  <Row justify="end" align="middle">
                    <Col span={24}>
                      <Popconfirm
                        title="¿Deseas enviar los recordatorios ahora? Esta acción enviará correos a todos los clientes con cuentas por cobrar pendientes."
                        description="Se enviarán correos a todos los clientes con cuentas por cobrar pendientes."
                        okText="Sí, enviar"
                        cancelText="No"
                        onConfirm={() => this.enviarRecordatoriosAhora()}
                        onCancel={() => message.info("Envío cancelado.")}
                        okButtonProps={{ danger: false, type: "primary" }}
                      >
                        <ButtonItem type="primary" disabled loading={this.state.loading}>
                          Enviar recordatorios ahora
                        </ButtonItem>
                      </Popconfirm>
                    </Col>
                  </Row>
                </div>
              </TabPane>
              <TabPane
                tab="Clientes con cuentas por cobrar"
                key={2}
                forceRender
              >
                <Alert
                  message="Selecciona los clienes a los que NO quieres enviar el recordatorio por correo. Esto aplica para envios automaticos o manuales."
                  type="info"
                  showIcon
                  style={{ marginBottom: 20 }}
                />
                {hayCambiosEnClientes && (
                  <Alert
                    message="Hay cambios en la selección de clientes excluidos. Recuerda GUARDAR la configuración en la pestaña 'Configuración de Recordatorios' para aplicar estos cambios."
                    type="warning"
                    showIcon
                    style={{ marginBottom: 20 }}
                  />
                )}
                <TableItem
                  style={{ marginTop: 10 }}
                  rowKey={(value) => value._id || value.id || value.cliente}
                  columns={columnsClientes}
                  rowSelection={rowSelection}
                  dataSource={clientesConDeuda}
                  size="small"
                  pagination={{ pageSize: 6 }}
                />
              </TabPane>
              <TabPane tab="Historial de Recordatorios" key={3} forceRender>
                <Paragraph strong style={{ marginBottom: 5 }}>
                  Filtrar por Fecha:
                </Paragraph>
                <Row gutter={8} align="middle">
                  <Col xs={24} sm={12} md={8}>
                    <RangePicker
                      onChange={this.onChangeRangoFechas}
                      value={[fechaInicio, fechaFin]}
                      format="DD/MM/YYYY"
                      style={{ width: "100%" }}
                      placeholder={["Fecha Inicio", "Fecha Fin"]}
                    />
                  </Col>
                </Row>
                <TableItem
                  style={{ marginTop: 10 }}
                  rowKey={(value) => value._id}
                  columns={columnsHistorial}
                  dataSource={historialFiltrado}
                  size="small"
                  pagination={{
                    pageSize: 10,
                    showTotal: (total) => `Total: ${total} registros`,
                  }}
                  rowClassName={() => "table-row-light"}
                />
              </TabPane>
              <TabPane tab="Configuración Avanzada" key={4} forceRender>
                <div
                  style={{
                    backgroundColor: "white",
                    padding: 20,
                    borderRadius: 10,
                    border: "1px solid #f0f0f0",
                  }}
                >
                  <Title strong level={4}>
                    Correo de Reenvío
                  </Title>
                  <Alert
                    message="El correo de reenvío recibirá una copia de todos los correos que se envíen desde el sistema. Útil para monitorear los envíos realizados."
                    type="info"
                    showIcon
                    style={{ marginBottom: 20 }}
                  />
                  <Form ref={this.formRefAvanzada} layout="vertical">
                    <Row gutter={16}>
                      <Col xs={24} sm={12} md={8}>
                        <FormItem
                          name="correoReenvio"
                          label="Correo de reenvío"
                        >
                          <InputItem placeholder="ejemplo@correo.com" />
                        </FormItem>
                      </Col>
                    </Row>
                    <Row>
                      <FormItem
                        name="correoReenvioActivo"
                        label="Activar correo de reenvío"
                        valuePropName="checked"
                        initialValue={false}
                        margin
                      >
                        <SwitchItem />
                      </FormItem>
                    </Row>
                    <Alert
                      message="Cuando está activado, este correo recibirá una copia de cada correo enviado a los clientes (recordatorios automáticos y manuales)."
                      type="warning"
                      showIcon
                      style={{ marginBottom: 20 }}
                    />
                    <Row justify="end">
                      <Col>
                        <ButtonItem
                          type="primary"
                          onClick={this.handleGuardarAvanzado}
                          loading={this.state.loading}
                        >
                          Guardar configuración avanzada
                        </ButtonItem>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </TabPane>
            </Tabs>
          </Spin>
        </div>
        <ModalDetalleEnvio
          visible={modalDetalleVisible}
          onCancel={this.handleCloseModal}
          data={detalleEnvioId}
        />
        <ModalMandarEstadoCuenta
          visible={this.state.modalMandarCorreoVisible}
          onCancel={this.cerrarModalMandarCorreo}
          clienteId={this.state.clienteIdParaCorreo}
          sinRemisiones={this.state.sinRemisionesParaCorreo}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  usuarioId: state.user.usuarioId,
});

export default connect(mapStateToProps)(ProgramarRecordatorios);
